import { useShelvingStore, useStoreSystem, useStoreRoom } from "../../store";
import { isNewSite } from "../isNewSite";

export const getItemsCost = () => {
    const isNew = isNewSite();

    const itemsGroup = useStoreSystem.getState().itemsGroup;
    const shelving = useShelvingStore.getState().shelving;
    const tireRacks = useStoreRoom.getState().tireRacks;

    const originItemsPrice = new Map();
    itemsGroup.forEach((itemGroup) => {
        itemGroup.ELEMENTS?.forEach((element) => {
            if (typeof element.PRICE !== "undefined") {
                originItemsPrice.set(element.BITRIX_OFFER_ID, element.PRICE);
            }
        });
    });

    const sections = [
        ...shelving.back.sections,
        ...shelving.front.sections,
        ...shelving.left.sections,
        ...shelving.right.sections,
    ];

    const itemsCost = sections.reduce(
        (sectionsAcc, section) =>
            sectionsAcc +
            section.items.reduce((acc, item) => {
                if (item.isSpirit) return acc;

                const elements = [];
                if (item.brackets.left.isVisible) elements.push(...item.brackets.left.elements);
                if (item.brackets.right.isVisible) elements.push(...item.brackets.right.elements);

                const parts = item.parts.filter((element) => {
                    return item.edges?.filter((el) => el.bitrixId === element.bitrixId) !== undefined;
                });
                elements.push(...parts);

                const elementsCost = elements.reduce((acc, el) => acc + el.price, 0);

                return acc + (isNew ? item.price : originItemsPrice.get(item.bitrixId)) + elementsCost;
            }, 0),
        0
    );

    // Добавляем стоимость tire racks
    const tireRackCost = tireRacks.reduce((acc, tireRack) => {
        return acc + (tireRack.pricing?.total_cost || 0);
    }, 0);

    return itemsCost + tireRackCost;
};
